module.exports = __webpack_public_path__ + "static/media/Vue.40ba8726.png";